import React from 'react';

const Retail = () => {
  return (
    <div className="page">
      <h1>Retail Solutions</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default Retail; 